<div class="comparison-container">
  <div class="comparison-box old">
    <h4>Current {{propertyName | titlecase}}</h4>
    <div class="amount">
      {{currentValue}}
    </div>
  </div>
  <svg
    class="arrow-icon"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M17 8l4 4m0 0l-4 4m4-4H3"
    ></path>
  </svg>
  <div class="comparison-box new">
    <h4>New {{propertyName | titlecase}}</h4>
    <div class="amount">
      {{newValue}}
    </div>
  </div>
</div>
